var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('app-timeline',_vm._l((_vm.vehicule.historiques),function(item){return _c('app-timeline-item',{key:item.id,attrs:{"title":item.log,"subtitle":item.user,"time":item.date,"variant":"success"}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }